import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowRight, Clock } from "lucide-react";

export default function Courses() {
  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <Navbar variant="adult" />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 grid-bg-adult" />
        <div className="absolute inset-0 grain pointer-events-none" />
        <div data-testid="courses-coming-soon" className="max-w-4xl mx-auto px-6 py-28 relative">
          <div className="inline-flex items-center gap-2 rounded-full bg-violet-500/10 border border-violet-500/30 px-3 py-1 text-xs uppercase tracking-[0.2em] font-adult-mono text-violet-300">
            <Clock className="w-3 h-3" /> Coming soon
          </div>
          <h1 className="mt-6 font-adult-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.04]">
            Mini courses are <span className="font-adult-serif italic text-amber-400">on the way.</span>
          </h1>
          <p className="mt-6 text-zinc-400 text-lg leading-relaxed max-w-2xl">
            Snack-sized, recorded courses in SQL, Python and Power BI are being polished. Until then, learn live in the Weekend Bootcamp or join a live workshop with Sankalp.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/flagship" data-testid="courses-cta-bootcamp" className="inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 text-black font-semibold px-6 py-3 text-sm glow-amber transition-smooth">
              Weekend Bootcamp <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/meet-sankalp" data-testid="courses-cta-workshops" className="inline-flex items-center gap-2 rounded-full border border-zinc-800 hover:border-zinc-600 px-6 py-3 text-sm text-zinc-200 transition-smooth">
              Live workshops →
            </Link>
          </div>
        </div>
      </section>
      <Footer variant="adult" />
    </div>
  );
}
